module.exports = __webpack_public_path__ + "img/poter5.f5efebe3.jpg";